import {
    ChangeEvent,
    SyntheticEvent,
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";

import GridTemplate from "../../../components/GridTemplate";
import { SetterOrUpdater, useRecoilValue } from "recoil";
import { GridColDef } from "@mui/x-data-grid";

import {
    BadgeOutlined,
    CheckCircleRounded,
    CloseOutlined,
    DeleteForeverOutlined,
    DriveFileRenameOutlineOutlined,
    EmailOutlined,
    KeyOutlined,
    LockOpenOutlined,
    LockPersonOutlined,
    LockResetOutlined,
    NoAccountsRounded,
    RemoveCircleOutlineOutlined,
    SaveOutlined,
    VisibilityOffOutlined,
    VisibilityOutlined,
    VpnKeyOutlined,
} from "@mui/icons-material";

import {
    Autocomplete,
    Box,
    Button,
    Checkbox,
    Chip,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormHelperText,
    Grid,
    IconButton,
    InputLabel,
    Paper,
    Skeleton,
    Stack,
    Switch,
    SwitchProps,
    TextField,
    Typography,
    styled as styl
} from "@mui/material";

import {
    AccessRequestType,
    AccessType,
    DepartmentSimpleType,
    SecretarySimpleType,
    SelectedParametersType,
    UserPermissionsType,
    UserType,
    VehicleGroupType,
} from "../../../types/types";

import Rmodal from "../../../components/Rmodal";
import { ContentProps, Toast } from "primereact/toast";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";
import {
    getFilteredList,
    setToastRefToOpen,
} from "../../../functions/functions";

import { SimpleTreeView } from "@mui/x-tree-view";
import { TreeItem, treeItemClasses } from "@mui/x-tree-view/TreeItem";
import styled from "@emotion/styled";

import "./styles.css";

import { userAtom } from "../../../atoms/atoms";
import updateUserByCustomer from "../../../resources/Api/accesses/updateUserByCustomer";
import updateUserStatusById from "../../../resources/Api/accesses/updateUserStatusById";
import resetUserPasswordById from "../../../resources/Api/accesses/resetUserPasswordById";
import validator from "validator";
import findAllUsersExportResponse from "../../../resources/Api/accesses/findAllUsersExportResponse";
import findAllAcessesByCustomer from "../../../resources/Api/accesses/findAllAcessesByCustomer";
import findAllDepartmentsByCustomerIdAndSecretaryIdListResponse from "../../../resources/Api/department/findAllDepartmentsByCustomerIdAndSecretaryIdListResponse";
import findAllSecretariesByCustomerIdListResponse from "../../../resources/Api/secretary/findAllSecretariesByCustomerIdListResponse";
import findAllGroupsByCustomerIdAndSecretaryIdAndDepartmentIdListResponse from "../../../resources/Api/group/findAllGroupsByCustomerIdAndSecretaryIdAndDepartmentIdListResponse";
import { defaultManangerProfiles, itensCustomerPermissions, itensManagerPermissions, MENUS_ITENS, PROFILE_ACESSES, TECHNICIAN_MENU_IDS, userCustomerPermissionsDefault, userManagerPermissionsDefault, userTechnicianPermissionsDefault } from "../../../consts/consts";
import { useCustomerFeatures } from "../../../hooks/useCustomerFeatures";
import saveAcessesByCustomer from "../../../resources/Api/accesses/saveAcessesByCustomer";
import generateTokenByUser from "../../../resources/Api/accesses/generateTokenByUser";
import userFindAllSecretariesListResponse from "../../../resources/Api/user/userFindAllSecretariesListResponse";
import { isImpersonationLocked } from "../../../utils/impersonation";

const columns: GridColDef[] = [
    {
        field: "activated",
        type: "boolean",
        width: 150,
        editable: false,
        sortable: false,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Ativo"}
                icon={<KeyOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{ background: "transparent" }}
                icon={
                    item.row.activated ? (
                        <CheckCircleRounded
                            className="activated"
                            style={{ height: 28, width: 28 }}
                        />
                    ) : (
                        <NoAccountsRounded
                            className="deactivated"
                            style={{ height: 28, width: 28 }}
                        />
                    )
                }
            />
        ),
    },
    {
        field: "blocked",
        type: "boolean",
        width: 150,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Bloqueado"}
                icon={
                    <LockOpenOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />
                }
            />
        ),
        renderCell: (item) => (
            <div style={{ background: "transparent", fontFamily: "Prometo" }}>
                {item.row.blocked ? (
                    <Chip label={<Typography className="deactivated" fontSize={"14px"}>Sim</Typography>} />
                ) : (
                    <Chip label={<Typography className="activated" fontSize={"14px"}>Não</Typography>} />
                )}
            </div>
        ),
    },
    {
        field: "userAccessProfileId",
        headerName: "Perfil",
        align: "left",
        width: 200,
        editable: false,
        sortable: true,
        valueGetter: (_value, row: AccessType) =>
            defaultManangerProfiles.find((profile) => profile.id === row.userAccessProfileId)?.name ?? "-",
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label="Perfil"
                icon={<LockPersonOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{ background: "transparent", fontFamily: "Prometo" }}
                label={item.value}
            />
        ),
    },
    {
        field: "name",
        align: "left",
        width: 200,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Nome"}
                icon={
                    <BadgeOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />
                }
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row.name}
            />
        ),
    },
    {
        field: "email",
        align: "left",
        width: 200,
        headerClassName: "last-column",
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"E-mail"}
                icon={
                    <EmailOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />
                }
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row.email}
            />
        ),
    },
    {
        field: "accessIcon",
        sortable: false,
        headerName: "",
        width: 320,
        renderCell: (item) => (
            <>
                <Chip
                    className={`chip-access ${item.row?.showOptions ? "" : "d-none"}`}
                    sx={{
                        marginRight: 2,
                        fontFamily: "Prometo",
                        background: "#00B700",
                        color: "#ffff",
                        padding: 1,
                    }}
                    onClick={() => {
                        item.row?.callback?.(item.row.id, item.row.login);
                        localStorage.setItem("impersonating", "true");
                    }}
                    label="Acessar"
                    icon={
                        <VpnKeyOutlined style={{ height: 25, width: 25, fill: "#ffff" }} />
                    }
                />
            </>
        ),
    }
];

const rowsOptions = (
    list: Array<AccessType>,
    openDetails?: SetterOrUpdater<boolean>,
    callback?: (...args: any) => void,
    showOptions?: boolean
): Array<AccessType> => {
    const result = [...list];
    return result.map((item) => ({ ...item, openDetails, callback, showOptions }));
};

/**
 * AccessPage - Screen that renders a page to create and manage the system accesses
 * @component-screen
 */
const AccessPage = ({ isHiddenMenu }: { isHiddenMenu: boolean }) => {
    // atoms
    const getCurrentUser = useRecoilValue<UserType>(userAtom);
    const customerFeatures = useCustomerFeatures();

    // functionalities states
    const [isOnline, setIsOnline] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(false);
    const [validationText, setTextValidation] = useState<string>("");
    const [isFieldsValid, setFieldsIsValid] = useState<boolean>(true);
    const [statusMessage, setStatusMessage] = useState<
        "warn" | "success" | "info" | "error" | undefined
    >("warn");
    const [isToastVisible, setIsToastVisible] = useState(false);
    const [inEdit, setInEdit] = useState<boolean>(false);
    const [inInsert, setInInsert] = useState<boolean>(false);
    const [isOpenDetails, setIsOpenDetails] = useState<boolean>(false);
    const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false);

    const [isLastPage, setIsLastPage] = useState<boolean>(true);
    const [numberOfElementsPerPage, setNumberOfElementsPerPage] = useState<number>(0);
    const [numberOfElements, setNumberOfElements] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(0);

    // states
    const [query, setQuery] = useState<string>("");
    const [filteredList, setFilteredList] = useState<Array<AccessType>>([]);
    const [selectedAccess, setSelectedAcess] = useState<AccessType>({
        id: -1,
        name: "",
        activated: true,
        blocked: false,
        email: "",
        permissions: [],
        departments: [],
        secretaries: [],
        userAccessProfileId: -1,
        driverCpf: "",
        driverRegistration: "",
        useRegisterNumber: false,
        groups: [],
        isDriver: false,
        isManager: false,
        vehicleList: null,
        login: null,
        useGtf: false
    });

    const [accessesList, setAcessesList] = useState<Array<AccessType>>([]);
    const [name, setName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [login, setLogin] = useState<string | null>(null);
    const [password, setPassword] = useState<string>("");
    const [isWeakPassword, setIsWeakPassword] = useState(false);
    const [userAccessProfileName, setUserAccessProfileName] = useState<string>("");

    const [access, setAccess] = useState<Array<UserPermissionsType | any>>(
        getCurrentUser.configs.isManager ? userManagerPermissionsDefault : userCustomerPermissionsDefault
    );

    const [selectedSecretariesList, setSelectedSecretariesList] = useState<Array<string>>([]);
    const [selectedDepartmentsList, setSelectedDepartmentList] = useState<Array<string>>([]);
    const [selectedGroupsList, setSelectedGroupsList] = useState<Array<string>>([]);

    const [secretariesList, setSecretariesList] = useState<Array<SecretarySimpleType>>([]);
    const [departmentsList, setDepartmentsList] = useState<Array<DepartmentSimpleType>>([]);
    const [groupsList, setGroupsList] = useState<Array<VehicleGroupType>>([]);

    const [report, setReport] = useState<ArrayBuffer>(new ArrayBuffer(0));
    const [exportType, setExportType] = useState<string>("");

    const [expandedGroup, setExpandedGroup] = useState<string | null>(null);
    const [expandAllPermissions, setExpandAllPermissions] = useState<boolean>(false);
    const [useGtf, setUseGtf] = useState<boolean>(false);

    // refs
    const toastModalRef = useRef<Toast>(null);
    const toastRef = useRef<Toast>(null);

    // cookies
    const [cookies, setCookie, removeCookies] =
        useCookies(["selectedParameters", "token", "oldToken", "oldSelectedParameters"]);

    const location = useLocation();

    const disabledPermissionIds = useMemo(() => {
        if (getCurrentUser.configs.isManager) return [];
        return [
            ...(!customerFeatures?.useWorkSchedules ? [MENUS_ITENS.WORK_SCHEDULES] : []),
            ...(!customerFeatures?.useCalculatedRoutes ? [MENUS_ITENS.ROUTES] : []),
            ...(!customerFeatures?.useCheckList ? [MENUS_ITENS.CHECK_LIST] : []),
            ...(!customerFeatures?.useVideoTelemetry ? [MENUS_ITENS.VIDEO_TELEMETRY] : []),
        ] as string[];
    }, [getCurrentUser.configs.isManager, customerFeatures]);

    const accessForSave = useMemo(() => access.map((permission) =>
        disabledPermissionIds.includes(String(permission.optionItemId))
            ? { ...permission, canView: false, canCreate: false, canEdit: false, canDelete: false }
            : permission
    ), [access, disabledPermissionIds]);

    const gridColumns = useMemo(
        () => columns.filter((column) => column.field !== "userAccessProfileId" ||
            (getCurrentUser.configs.isManager && !location?.state?.customerId)),
        [getCurrentUser.configs.isManager, location?.state?.customerId]
    );

    const isAdmin = useMemo(
        () => getCurrentUser.configs.isManager && String(getCurrentUser.accessProfile.id) === PROFILE_ACESSES.ADMIN,
        [getCurrentUser.configs.isManager, getCurrentUser.accessProfile.id]
    );

    const handleExpandToggle = (groupId: string) => {
        setExpandedGroup((prevGroup) => (prevGroup === groupId ? null : groupId));
    };

    const handleClose = useCallback(() => {
        setLoading(false);
        setStatusMessage("warn");
        setIsToastVisible(false);
        setFieldsIsValid(true);
        setTextValidation("");
        setIsOpenDetails(false);
        setSelectedAcess({
            id: -1,
            name: "",
            activated: true,
            blocked: false,
            email: "",
            permissions: [],
            departments: [],
            secretaries: [],
            userAccessProfileId: -1,
            driverCpf: "",
            driverRegistration: "",
            useRegisterNumber: false,
            groups: [],
            isDriver: false,
            isManager: false,
            vehicleList: null,
            login: null,
            useGtf: false
        });
        setInEdit(false);
        setInInsert(false);
        setName("");
        setPassword("");
        setEmail("");
        setUserAccessProfileName("");
        setSelectedDepartmentList([]);
        setSelectedSecretariesList([]);
        setSelectedGroupsList([]);
        setAccess(getCurrentUser.configs.isManager ? userManagerPermissionsDefault : userCustomerPermissionsDefault);
        setExpandedGroup(null);
        setExpandAllPermissions(false);
        setLogin(null);
        setUseGtf(false);
    }, [getCurrentUser.configs.isManager]);

    useEffect(() => {
        const ref = isOpenDetails ? toastModalRef : toastRef;
        if (validationText && !isFieldsValid && !isToastVisible) {
            setToastRefToOpen(
                ref,
                validationText,
                "Atenção!",
                statusMessage,
                undefined,
                3000,
                false
            );
        }
    }, [
        isOpenDetails,
        validationText,
        isFieldsValid,
        statusMessage,
        isToastVisible,
    ]);

    const getSecretariesListByUserId = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        const userId = getCurrentUser.id;
        try {
            const response = await userFindAllSecretariesListResponse(
                token,
                userId
            );
            if (response.data.length > 0) {
                setSecretariesList(response.data);
            }
        } catch (error) {
            console.log(error);
            setSecretariesList([]);
        }
    }, [cookies.token, getCurrentUser.id]);

    const getSecretariesList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        const customerId = location?.state?.customerId ?? getCurrentUser.customer.id;

        try {
            const response = await findAllSecretariesByCustomerIdListResponse(
                token,
                customerId
            );
            setSecretariesList(response.data);
        } catch (error) {
            console.log(error);
            setSecretariesList([]);
        }
    }, [cookies.token, getCurrentUser.customer.id, location?.state?.customerId]);

    useEffect(() => {
        if (getCurrentUser.configs.isManager && location?.state.customerId) {
            getSecretariesList();
        } else if (!getCurrentUser.configs.isManager) {
            getSecretariesListByUserId();
        }
    }, [getSecretariesList, getSecretariesListByUserId, getCurrentUser.configs.isManager, location?.state.customerId]);

    const getDepartmentsList = useCallback(async (secretaryIds: string[]) => {
        const token = cookies.token || sessionStorage.getItem("token");
        const customerId = location?.state.customerId ?? getCurrentUser.customer.id;
        const addList = secretaryIds.filter(secId => !departmentsList.map(dep => dep.secretaryId).includes(Number(secId)));
        const removeList = departmentsList.map(dep => dep.secretaryId).filter(secId => !secretaryIds.includes(String(secId)));
        const updatedDepartmentsList = [...departmentsList];

        if (addList.length > 0) {
            try {
                for (const secId of addList) {
                    const response = await findAllDepartmentsByCustomerIdAndSecretaryIdListResponse(
                        token,
                        customerId,
                        Number(secId)
                    );
                    updatedDepartmentsList.push(...response.data);
                }
                const uniqueDepartments = new Map(updatedDepartmentsList.map((item) => [item.id, item])).values();
                setDepartmentsList([...uniqueDepartments]);
            } catch (error) {
                console.error(error);
                setDepartmentsList([]);
            }
        }

        if (removeList.length > 0) {
            const secretaryId = removeList[0];
            const values = departmentsList.filter(item => item.secretaryId !== secretaryId);
            const departs = selectedDepartmentsList.filter(depId => values.map(dep => dep.id).includes(Number(depId)));
            setSelectedGroupsList(departs); setDepartmentsList(values);
        }
    }, [cookies.token, getCurrentUser.customer.id, location?.state?.customerId, departmentsList, selectedDepartmentsList]);

    const getGroupsList = useCallback(async (departmentIds: string[]) => {
        const token = cookies.token || sessionStorage.getItem("token");
        const customerId = location?.state.customerId ?? getCurrentUser.customer.id;
        const addList = departmentIds.filter(depId => !groupsList.map(dep => dep.departmentId).includes(Number(depId)));
        const removeList = groupsList.map(dep => dep.departmentId).filter(depId => !departmentIds.includes(String(depId)));
        const updatedGroupsList = [...groupsList];

        if (addList.length > 0) {
            try {
                for (const depId of addList) {
                    const response = await findAllGroupsByCustomerIdAndSecretaryIdAndDepartmentIdListResponse(
                        token,
                        customerId,
                        getCurrentUser.id,
                        Number(depId),
                        "activated"
                    );
                    updatedGroupsList.push(...response.data);
                }
                const uniqueGroups = new Map(updatedGroupsList.map((item) => [item.id, item])).values();
                setGroupsList([...uniqueGroups]);
            } catch (error) {
                console.error(error);
                setGroupsList([]);
            }
        }

        if (removeList.length > 0) {
            const departmentId = removeList[0];
            const values = groupsList.filter(item => item.departmentId !== departmentId);
            const groups = selectedGroupsList.filter(grpId => values.map(group => group.id).includes(Number(grpId)));
            setSelectedGroupsList(groups);
            setGroupsList(values);
        }
    }, [cookies.token, getCurrentUser.id, getCurrentUser.customer.id, location?.state?.customerId, groupsList, selectedGroupsList]);

    const getAllAccesses = useCallback(
        async (search: string = "", status: string = "activated", page: number = 0, size: number = 100) => {
            const token: string = cookies.token || sessionStorage.getItem("token");;
            const customerId = location?.state?.customerId ?? getCurrentUser.customer.id;
            const customerType = (location?.state?.customerId ? "customer" : (getCurrentUser.configs.isManager ? "manager" : "customer"));

            setLoading(true);
            try {
                const { data } = await findAllAcessesByCustomer(
                    token,
                    customerId,
                    getCurrentUser.id,
                    customerType,
                    status,
                    page,
                    size,
                    search
                );
                setAcessesList(data.content);
                setIsLastPage(data.last);
                setNumberOfElementsPerPage(data.numberOfElements);
                setPageNumber(data.pageable.pageNumber);

                if (data.first) {
                    setNumberOfElements(data.totalElements);
                }
            } catch (error: any) {
                console.log(error);
                setAcessesList([]);
            } finally {
                setTimeout(() => {
                    setLoading(false);
                }, 2000);
            }
        },
        [
            location?.state?.customerId,
            getCurrentUser.configs.isManager,
            getCurrentUser.id,
            getCurrentUser.customer.id,
            cookies.token
        ]
    );

    useEffect(() => {
        getAllAccesses();
    }, [getAllAccesses]);

    const onSave = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const customerId = location?.state?.customerId ?? getCurrentUser.customer.id;
        const customerType = (location?.state?.customerId ? "customer" : (getCurrentUser.configs.isManager ? "manager" : "customer"));
        const profileId = getCurrentUser.configs.isManager ? defaultManangerProfiles.find(item => item.name === userAccessProfileName)?.id!! : getCurrentUser.accessProfile.id;

        setLoading(true);
        const data: AccessRequestType = {
            id: -1,
            name: name,
            email: email,
            login: useGtf ? login : null,
            useGtf: useGtf,
            password: password,
            customerId: customerType === "manager" ? null : customerId,
            permissions: location?.state?.customerId ? null : accessForSave,
            userAccessProfileId: location?.state?.customerId ? Number(PROFILE_ACESSES.CUSTOMER_ADMIN) : profileId,
            secretaries: (location?.state?.customerId || !getCurrentUser.configs.isManager) ? selectedSecretariesList : null,
            departments: (location?.state?.customerId || !getCurrentUser.configs.isManager) ? selectedDepartmentsList : null,
            groups: (location?.state?.customerId || !getCurrentUser.configs.isManager) ? selectedGroupsList : null,
            driver: null,
            vehicles: null
        };

        if (
            (data.useGtf && !data.login) ||
            !data.name ||
            !data.email ||
            !data.password ||
            data.permissions?.length === 0 ||
            (customerType === "manager" && !(data.userAccessProfileId && data.userAccessProfileId !== Number(PROFILE_ACESSES.CUSTOMER_ADMIN) && data.userAccessProfileId > 0))
        ) {
            setTextValidation(
                "Todos os campos marcados com * são obrigatórios, preencha e tente novamente."
            );
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        if (isWeakPassword) {
            const txt = useGtf ? "A senha deve ter no mínimo 6 digitos." : "A senha deve ter no mínimo 8 digitos, conter uma letra maiúscula, uma letra minúscula, números e pelo menos um caractere especial.";
            setTextValidation(
                txt
            );
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        try {
            await saveAcessesByCustomer(
                token,
                data,
                customerType
            );
            setTextValidation("Registro salvo com sucesso.");
            setStatusMessage("success");
            setFieldsIsValid(false);

            setTimeout(() => {
                handleClose();
                getAllAccesses();
            }, 3000);
        } catch (error: any) {
            setLoading(false);
            const { data } = error.response;

            const errors = data.reason.split(".");
            errors.forEach((message: any, index: number) => {
                if (index === 0) {
                    setFieldsIsValid(false);
                    setStatusMessage("warn");
                    setTextValidation(message);
                }
            });
        }
    }, [
        name,
        password,
        useGtf,
        login,
        email,
        cookies.token,
        handleClose,
        getAllAccesses,
        getCurrentUser.configs.isManager,
        selectedGroupsList,
        getCurrentUser.customer.id,
        getCurrentUser.accessProfile.id,
        location?.state?.customerId,
        selectedSecretariesList,
        selectedDepartmentsList,
        userAccessProfileName,
        isWeakPassword,
        accessForSave
    ]);

    const onUpdate = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const customerId = location?.state?.customerId ?? getCurrentUser.customer.id;
        const customerType = (location?.state?.customerId ? "customer" : (getCurrentUser.configs.isManager ? "manager" : "customer"));
        const profileId = getCurrentUser.configs.isManager ? defaultManangerProfiles.find(item => item.name === userAccessProfileName)?.id!! : getCurrentUser.accessProfile.id;

        setLoading(true);
        const data: AccessRequestType = {
            id: selectedAccess.id!!,
            name: name,
            email: email,
            login: useGtf ? login : null,
            useGtf: useGtf,
            permissions: location?.state?.customerId ? null : accessForSave,
            customerId: customerType === "manager" ? null : customerId,
            userAccessProfileId: location?.state?.customerId ? Number(PROFILE_ACESSES.CUSTOMER_ADMIN) : profileId,
            secretaries: location?.state?.customerId || !getCurrentUser.configs.isManager ? selectedSecretariesList : null,
            departments: location?.state?.customerId || !getCurrentUser.configs.isManager ? selectedDepartmentsList : null,
            groups: location?.state?.customerId || !getCurrentUser.configs.isManager ? selectedGroupsList : null,
            driver: null,
            vehicles: null
        };

        if ((data.useGtf && !data.login) || !data.name || !data.email || data.permissions?.length === 0) {
            setTextValidation(
                "Todos os campos são obrigatórios, preencha e tente novamente."
            );
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        const hasEqualLength = access.length === selectedAccess.permissions.length;
        const permissionElements = access.filter((ac) => {
            const value = selectedAccess.permissions.find(
                (a) => String(a.optionItemId) === ac.optionItemId
            );
            if (
                ac.canCreate !== value?.canCreate ||
                ac.canView !== value?.canView ||
                ac.canEdit !== value?.canEdit ||
                ac.canDelete !== value?.canDelete
            ) {
                return ac;
            }
        });

        const secs = data.secretaries;
        const hasSecretariesEqualLength = secs?.length === selectedAccess.secretaries.length;
        const haveSecretariesSameElements = secs?.every((secId) => selectedAccess.secretaries.includes(Number(secId)));
        const hasChangesOnScretaries = !hasSecretariesEqualLength || !haveSecretariesSameElements;

        const dep = data.departments;
        const hasDepartmentsEqualLength = dep?.length === selectedAccess.departments.length;
        const haveDepartmentsSameElements = dep?.every((depId) => selectedAccess.departments.includes(Number(depId)));
        const hasChangesOnDepartments = !hasDepartmentsEqualLength || !haveDepartmentsSameElements;

        const grp = data.groups;
        const hasGroupsEqualLength = grp?.length === selectedAccess.groups.length;
        const haveGroupsSameElements = grp?.every((grpId) => selectedAccess.groups.includes(Number(grpId)));
        const hasChangesOnGroups = !hasGroupsEqualLength || !haveGroupsSameElements;

        const hasChangesOnPermissions =
            !hasEqualLength || permissionElements.length > 0;
        if (
            useGtf === selectedAccess.useGtf &&
            login === selectedAccess.login &&
            name === selectedAccess.name &&
            email === selectedAccess.email &&
            !hasChangesOnPermissions &&
            ((location?.state?.customerId || !getCurrentUser.configs.isManager) && (!hasChangesOnScretaries &&
                !hasChangesOnDepartments &&
                !hasChangesOnGroups))
        ) {
            setTextValidation("Nada foi alterado.");
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        try {
            await updateUserByCustomer(
                token,
                data.id,
                data,
            );
            setTextValidation("Registro atualizado com sucesso.");
            setStatusMessage("success");
            setFieldsIsValid(false);

            setTimeout(() => {
                handleClose();
                getAllAccesses();
            }, 3000);
        } catch (error: any) {
            setLoading(false);
            const { data } = error.response;

            const errors = data.reason.split(".");
            errors.forEach((message: any, index: number) => {
                if (index === 0) {
                    setFieldsIsValid(false);
                    setStatusMessage("warn");
                    setTextValidation(message);
                }
            });
        }
    }, [
        name,
        login,
        useGtf,
        email,
        access,
        selectedAccess,
        userAccessProfileName,
        getCurrentUser.accessProfile.id,
        getCurrentUser.configs.isManager,
        location?.state?.customerId,
        selectedSecretariesList,
        selectedDepartmentsList,
        selectedGroupsList,
        getCurrentUser.customer.id,
        cookies.token,
        handleClose,
        getAllAccesses,
        accessForSave,
    ]);

    const verifyBeforeCancel = useCallback(
        (selected: AccessType) => {
            const ref = toastModalRef;
            let canCancel = true;

            const secs = location?.state?.customerId || !getCurrentUser.configs.isManager ? selectedSecretariesList : null;
            const deps = location?.state?.customerId || !getCurrentUser.configs.isManager ? selectedDepartmentsList : null;
            const grps = location?.state?.customerId || !getCurrentUser.configs.isManager ? selectedGroupsList : null;

            if (inEdit && !inInsert) {
                const hasEqualLength = access.length === selected.permissions.length;
                const permissionElements = access.filter((ac) => {
                    const value = selected.permissions.find(
                        (a) => String(a.optionItemId) === ac.optionItemId
                    );

                    if (
                        ac.canCreate !== value?.canCreate ||
                        ac.canView !== value?.canView ||
                        ac.canEdit !== value?.canEdit ||
                        ac.canDelete !== value?.canDelete
                    ) {
                        return ac;
                    }
                });

                const hasSecretariesEqualLength = secs?.length === selected.secretaries.length;
                const haveSecretariesSameElements = secs?.every((secId) => selected.secretaries.includes(Number(secId)));
                const hasChangesOnScretaries = !hasSecretariesEqualLength || !haveSecretariesSameElements;

                const hasDepartmentsEqualLength = deps?.length === selected.departments.length;
                const haveDepartmentsSameElements = deps?.every((depId) => selected.departments.includes(Number(depId)));
                const hasChangesOnDepartments = !hasDepartmentsEqualLength || !haveDepartmentsSameElements;

                const hasGroupsEqualLength = grps?.length === selected.groups.length;
                const haveGroupsSameElements = grps?.every((grpId) => selected.groups.includes(Number(grpId)));
                const hasChangesOnGroups = !hasGroupsEqualLength || !haveGroupsSameElements;

                const hasChangesOnPermissions = !hasEqualLength || permissionElements.length > 0;
                if (
                    useGtf !== selected.useGtf ||
                    login !== selected.login ||
                    name !== selected.name ||
                    email !== selected.email ||
                    hasChangesOnPermissions ||
                    ((location?.state?.customerId || !getCurrentUser.configs.isManager) && (hasChangesOnScretaries ||
                        hasChangesOnDepartments ||
                        hasChangesOnGroups))
                ) {
                    canCancel = false;
                }
            } else if (
                !inEdit &&
                inInsert
            ) {
                if (
                    (getCurrentUser.configs.isManager && location?.state?.customerId && useGtf) ||
                    (getCurrentUser.configs.isManager && location?.state?.customerId && login) ||
                    name ||
                    email ||
                    password ||
                    (!location?.state?.customerId || !getCurrentUser.configs.isManager) && access.some((item) => !item.canCreate || !item.canView || !item.canEdit) ||
                    ((location?.state?.customerId || !getCurrentUser.configs.isManager) && secs!!.length > 0) ||
                    ((location?.state?.customerId || !getCurrentUser.configs.isManager) && deps!!.length > 0) ||
                    ((!getCurrentUser.configs.isManager) && grps!!.length > 0)
                ) {
                    canCancel = false;
                }
            }

            if (!canCancel) {
                if (!isToastVisible) {
                    setToastRefToOpen(
                        ref,
                        "Existem dados não salvos, deseja realmente cancelar?",
                        "Atenção!",
                        statusMessage,
                        {
                            content: (props: ContentProps) => (
                                <Box
                                    className="flex flex-column align-items-left"
                                    style={{ flex: "1" }}
                                >
                                    <Typography>{props?.message.summary}</Typography>
                                    <Box className="font-medium text-lg my-3 text-900">
                                        {props?.message.detail}
                                    </Box>
                                    <Button
                                        className="p-button-sm flex"
                                        style={{ cursor: "pointer", color: "inherit" }}
                                        onClick={() => {
                                            ref.current?.clear();
                                            handleClose();
                                        }}
                                    >
                                        Sim
                                    </Button>
                                    <Button
                                        className="p-button-sm flex"
                                        style={{ cursor: "pointer", color: "inherit" }}
                                        onClick={() => {
                                            ref.current?.clear();
                                            setIsToastVisible(false);
                                        }}
                                    >
                                        Não
                                    </Button>
                                </Box>
                            ),
                        },
                        undefined,
                        true
                    );
                    setIsToastVisible(true);
                }
            } else {
                handleClose();
            }
        },
        [
            inEdit,
            inInsert,
            handleClose,
            login,
            useGtf,
            statusMessage,
            isToastVisible,
            location?.state?.customerId,
            getCurrentUser.configs.isManager,
            selectedDepartmentsList,
            selectedSecretariesList,
            selectedGroupsList,
            name,
            email,
            password,
            access,
        ]
    );

    const onUpdateStatus = useCallback(
        async (id: number, status: string) => {
            const token: string = cookies.token || sessionStorage.getItem("token");
            const customerId = location?.state?.customerId ?? getCurrentUser.customer.id;

            setLoading(true);
            try {
                await updateUserStatusById(
                    token,
                    id,
                    customerId,
                    status
                );

                setTextValidation("Registro atualizado com sucesso.");
                setStatusMessage("success");
                setFieldsIsValid(false);

                setTimeout(() => {
                    handleClose();
                    getAllAccesses();
                }, 8000);
            } catch (error: any) {
                const { data } = error.response;
                setLoading(false);
                setFieldsIsValid(false);
                setStatusMessage("warn");
                setTextValidation(data.reason);
            }
        },
        [cookies.token, getCurrentUser.customer.id, location?.state?.customerId, getAllAccesses, handleClose]
    );

    const verifyBeforeUpdateStatus = useCallback(
        (id: number, status: string) => {
            const ref = toastModalRef;
            if (!isToastVisible) {
                setToastRefToOpen(
                    ref,
                    "Deseja realmente atualizar o status desse registro?",
                    "Atenção!",
                    statusMessage,
                    {
                        content: (props: ContentProps) => (
                            <Box
                                className="flex flex-column align-items-left"
                                style={{ flex: "1" }}
                            >
                                <Typography>{props?.message.summary}</Typography>
                                <Box className="font-medium text-lg my-3 text-900">
                                    {props?.message.detail}
                                </Box>
                                <Button
                                    className="p-button-sm flex"
                                    style={{ cursor: "pointer", color: "inherit" }}
                                    onClick={() => {
                                        ref.current?.clear();
                                        setIsToastVisible(false);
                                        onUpdateStatus(id, status);
                                    }}
                                >
                                    Sim
                                </Button>
                                <Button
                                    className="p-button-sm flex"
                                    style={{ cursor: "pointer", color: "inherit" }}
                                    onClick={() => {
                                        ref.current?.clear();
                                        setIsToastVisible(false);
                                    }}
                                >
                                    Não
                                </Button>
                            </Box>
                        ),
                    },
                    undefined,
                    true
                );
                setIsToastVisible(true);
            }
        },
        [onUpdateStatus, isToastVisible, statusMessage]
    );

    const onResetPassword = useCallback(
        async (id: number) => {
            const token: string = cookies.token || sessionStorage.getItem("token");
            const customerId = location?.state?.customerId ?? getCurrentUser.customer.id;

            setLoading(true);
            try {
                await resetUserPasswordById(token, id, customerId);

                setTextValidation("Senha resetada para a senha padrão com sucesso.");
                setStatusMessage("success");
                setFieldsIsValid(false);

                setTimeout(() => {
                    handleClose();
                    getAllAccesses();
                }, 8000);
            } catch (error: any) {
                setLoading(false);
                setFieldsIsValid(false);
                setStatusMessage("warn");
                setTextValidation(error.response?.data?.reason ?? "Não foi possível resetar a senha do usuário.");
            }
        },
        [cookies.token, getCurrentUser.customer.id, location?.state?.customerId, getAllAccesses, handleClose]
    );

    const verifyBeforeResetPassword = useCallback(
        (id: number) => {
            const ref = toastModalRef;
            if (!isToastVisible) {
                setToastRefToOpen(
                    ref,
                    "Deseja realmente resetar a senha desse usuário para a senha padrão?",
                    "Atenção!",
                    statusMessage,
                    {
                        content: (props: ContentProps) => (
                            <Box
                                className="flex flex-column align-items-left"
                                style={{ flex: "1" }}
                            >
                                <Typography>{props?.message.summary}</Typography>
                                <Box className="font-medium text-lg my-3 text-900">
                                    {props?.message.detail}
                                </Box>
                                <Button
                                    className="p-button-sm flex"
                                    style={{ cursor: "pointer", color: "inherit" }}
                                    onClick={() => {
                                        ref.current?.clear();
                                        setIsToastVisible(false);
                                        onResetPassword(id);
                                    }}
                                >
                                    Sim
                                </Button>
                                <Button
                                    className="p-button-sm flex"
                                    style={{ cursor: "pointer", color: "inherit" }}
                                    onClick={() => {
                                        ref.current?.clear();
                                        setIsToastVisible(false);
                                    }}
                                >
                                    Não
                                </Button>
                            </Box>
                        ),
                    },
                    undefined,
                    true
                );
                setIsToastVisible(true);
            }
        },
        [onResetPassword, isToastVisible, statusMessage]
    );

    const [debouncedQuery, setDebouncedQuery] = useState(query);
    const [lastRemoteQuery, setLastRemoteQuery] = useState("");

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedQuery(query);
        }, 1000); // tempo para considerar que PAROU de digitar

        return () => clearTimeout(handler);
    }, [query]);

    const getBySearch = useCallback(() => {
        const localResult = getFilteredList(
            ["name", "cpf", "email", "cnh"],
            accessesList,
            debouncedQuery
        );

        if (localResult.length > 0) {
            setFilteredList(localResult);
        } else {
            setFilteredList([]);
        }

        // → evita loop: só chama API se query mudou
        if (debouncedQuery !== lastRemoteQuery && localResult.length <= 0) {
            setLastRemoteQuery(debouncedQuery);
            getAllAccesses(debouncedQuery);
        }
    }, [
        debouncedQuery,
        accessesList,
        getAllAccesses,
        lastRemoteQuery
    ]);

    useEffect(() => {
        getBySearch();
    }, [getBySearch]);

    const handleChange = useCallback((name: string, value: string) => {
        if (name === "name") {
            setName(value);
        }
        if (name === "email") {
            setEmail(value);
        }
        if (name === "password") {
            setPassword(value);
        }
        if (name === "login") {
            setLogin(value);
        }
    }, []);

    const handleItemSelectionToggle = useCallback(
        (itemId: string, permission: string, checked: boolean) => {
            const updatedValues = [...access];

            const itemIndex = updatedValues.findIndex(
                (item) => item.optionItemId === itemId
            );

            if (itemIndex !== -1) {
                updatedValues[itemIndex] = {
                    ...updatedValues[itemIndex],
                    [permission]: checked,
                };
            } else {
                updatedValues.push({
                    optionItemId: itemId,
                    canView: false,
                    canCreate: false,
                    canEdit: false,
                    canDelete: false,
                    [permission]: checked,
                });
            }
            setAccess(updatedValues);
        },
        [access]
    );

    const handleOnEditValues = useCallback(
        async (selectedAccess: AccessType) => {
            if (selectedAccess.name && !inInsert) {
                setName(selectedAccess.name);
                setEmail(selectedAccess.email);
                setLogin(selectedAccess.login);
                setUseGtf(selectedAccess.useGtf);
                setAccess(
                    selectedAccess.permissions.map((item) => ({
                        ...item,
                        optionItemId: String(item.optionItemId),
                    }))
                );
                setUserAccessProfileName(defaultManangerProfiles.find(item => item.id === selectedAccess.userAccessProfileId)?.name!!);
                setSelectedSecretariesList(selectedAccess.secretaries.map(it => it.toString()));
                await getDepartmentsList(selectedAccess.secretaries.map(it => it.toString()));
                setSelectedDepartmentList(selectedAccess.departments.map(it => it.toString()));

                await getGroupsList(selectedAccess.departments.map(it => it.toString()));
                setSelectedGroupsList(selectedAccess.groups.map(it => it.toString()));
            }
        },
        [inInsert, getDepartmentsList, getGroupsList]
    );

    const validate = useCallback((value: string) => {
        if (useGtf) {
            if (
                validator.isStrongPassword(value, {
                    minLength: 6,
                    minLowercase: 0,
                    minUppercase: 0,
                    minNumbers: 0,
                    minSymbols: 0,
                })
            ) {
                setIsWeakPassword(false);
            } else {
                setIsWeakPassword(true);
            }
        } else {
            if (
                validator.isStrongPassword(value, {
                    minLength: 8,
                    minLowercase: 1,
                    minUppercase: 1,
                    minNumbers: 1,
                    minSymbols: 1,
                })
            ) {
                setIsWeakPassword(false);
            } else {
                setIsWeakPassword(true);
            }
        }
    }, [useGtf]);

    useEffect(() => {
        if (password) {
            validate(password);
        }
    }, [password, validate]);

    const getReport = useCallback(async (type: string) => {
        setLoading(true);
        const customerId = location?.state?.customerId ?? getCurrentUser.customer.id;
        const customerType = location?.state?.customerId ? "customer" : getCurrentUser.configs.isManager ? "manager" : "customer";

        let reportType = type;
        let isSimpleType = false;
        if (type.includes("simple")) {
            reportType = reportType.split(" ")[0];
            isSimpleType = true;
        };
        // simpleXlsxExport = false

        let dataBuffer = new ArrayBuffer(0);
        try {
            const { data } = await findAllUsersExportResponse(
                cookies.token,
                customerId,
                accessesList.length > 0 && accessesList[0].activated
                    ? "activated"
                    : "deactivated",
                reportType,
                customerType,
                isSimpleType
            );

            if ((data as ArrayBuffer).byteLength === 0) {
                setTextValidation("Nenhum dado para mostrar no relatório.");
                setStatusMessage("warn");
                setFieldsIsValid(false);
            } else {
                setTextValidation("Relatório gerado com sucesso.");
                setStatusMessage("success");
                setFieldsIsValid(false);
                dataBuffer = data;
            }
        } catch (error: any) {
            const { data } = error.response

            setLoading(false);
            setFieldsIsValid(false);
            setStatusMessage("warn");
            setTextValidation(data.reason);
        } finally {
            setTimeout(() => {
                handleClose();
                setReport(dataBuffer);
                setExportType(type);
            }, 3000);
        }
    }, [
        cookies.token,
        getCurrentUser.customer.id,
        getCurrentUser.configs.isManager,
        location?.state?.customerId,
        accessesList,
        handleClose
    ]);

    useEffect(() => {
        if (report.byteLength > 1) {
            const typeExport = (exportType === "pdf" ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            const file = new Blob([report], { type: typeExport });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            setReport(new ArrayBuffer(0));
        }
    }, [report, exportType]);

    const accessUser = useCallback(async (userId: number, userEmail: string) => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const currentParameters: SelectedParametersType = cookies.selectedParameters;
        try {
            const { data } = await generateTokenByUser(token, userEmail, userId);
            if (data) {
                setCookie("oldToken", token);
                setCookie("oldSelectedParameters", currentParameters);

                removeCookies("token");
                setTimeout(() => {
                    setCookie("token", data);
                    removeCookies("selectedParameters");
                    window.location.reload();
                }, 1000);
            }
        } catch (error: any) {
            const { data } = error.responsed;
            setLoading(false);
            setFieldsIsValid(false);
            setTextValidation(data.reason);
        }
    }, [cookies.selectedParameters, cookies.token, removeCookies, setCookie]);

    const loadingEsqueleton = useMemo(() => {
        return (
            <Grid
                className="container "
                sx={{
                    height: 650,
                    width: 950,
                }}
            >
                {Array.from(new Array(1)).map((_, i) => (
                    <Box key={i} sx={{ width: "100%", height: 650, padding: 5 }}>
                        <Skeleton height={56} />
                        <Skeleton height={56} />
                        <Skeleton height={56} />
                        <Skeleton variant="rectangular" width={"100%"} height={350} />
                    </Box>
                ))}
            </Grid>
        );
    }, []);

    const CustomTreeItem = styled(TreeItem)({
        [`& .${treeItemClasses.iconContainer}`]: {
            "& .close": {
                opacity: 0.3,
            },
        },
    });

    const IOSSwitch = useMemo(() => styl((props: SwitchProps) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: '#65C466',
                    opacity: 1,
                    border: 0,
                    ...theme.applyStyles('dark', {
                        backgroundColor: '#2ECA45',
                    }),
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: theme.palette.grey[100],
                ...theme.applyStyles('dark', {
                    color: theme.palette.grey[600],
                }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.7,
                ...theme.applyStyles('dark', {
                    opacity: 0.3,
                }),
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: '#E9E9EA',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
            ...theme.applyStyles('dark', {
                backgroundColor: '#39393D',
            }),
        },
    })), []);

    const DetailsModal = useMemo(() => {
        return (
            <Rmodal
                open={isOpenDetails}
                toast={
                    <Toast
                        ref={toastModalRef}
                        position="center"
                        onShow={() => {
                            setIsToastVisible(true);

                            if (validationText) {
                                setTimeout(() => {
                                    setFieldsIsValid(true);
                                    setIsToastVisible(false);
                                }, 3000);
                            }
                        }}
                    />
                }
            >
                <Paper
                    className="tw-flex tw-flex-col tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-shadow-2xl tw-transition-all tw-duration-300 tw-ease-gtr-smooth"
                    sx={style}
                >
                    <Box
                        className="row permissions-paper tw-m-0 tw-flex-1 tw-overflow-y-auto tw-bg-white tw-p-4 sm:tw-p-6"
                        sx={{
                            margin: 0,
                            width: "100%",
                            flex: 1,
                            overflowY: "auto",
                            backgroundColor: "#ffff",
                            boxShadow: "none",
                            padding: { xs: 2, sm: 3 },
                            scrollbarWidth: "thin",
                            scrollbarColor: "#006C77 transparent",
                            "& .MuiOutlinedInput-root": {
                                borderRadius: 2,
                                backgroundColor: "#ffff",
                                transition: "box-shadow 200ms ease, background-color 200ms ease",
                            },
                            "& .MuiOutlinedInput-root:hover": {
                                backgroundColor: "rgba(0, 108, 119, 0.02)",
                            },
                            "& .MuiOutlinedInput-root.Mui-focused": {
                                boxShadow: "0 0 0 3px rgba(0, 108, 119, 0.10)",
                            },
                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#006C77",
                            },
                        }}
                    >
                        {!loading ? (
                            <>
                                <Box className="col-sm-12 col-md-7 d-none d-md-flex">
                                    <Typography variant="body1" sx={{ fontWeight: "bolder" }}>
                                        Identificação
                                    </Typography>
                                </Box>
                                <Box
                                    className="col-sm-12 col-md-5"
                                    style={{ display: "flex", justifyContent: "end", flexWrap: "wrap", gap: 5 }}
                                >
                                    {selectedAccess?.name && (
                                        <>
                                            <Chip
                                                style={{
                                                    color: selectedAccess.activated
                                                        ? "#00B700"
                                                        : "#dc3545",
                                                    marginRight: 0,
                                                    width: "auto",
                                                    fontWeight: "bolder",
                                                }}
                                                clickable={false}
                                                onClick={() => { }}
                                                label={selectedAccess.activated ? "Ativo" : "Inativo"}
                                            />
                                            {selectedAccess.activated && (
                                                <Chip
                                                    style={{
                                                        color: "black",
                                                        marginRight: 0,
                                                        width: "auto",
                                                    }}
                                                    disabled={(location?.state?.customerId && !location?.state?.permissions?.canEdit && location?.state?.permissions?.canEdit !== undefined) || (!location?.state?.customerId && !location?.state?.canEdit) || isImpersonationLocked()}
                                                    onClick={() => {
                                                        setInEdit(true);
                                                    }}
                                                    label="Editar"
                                                    icon={
                                                        <DriveFileRenameOutlineOutlined
                                                            style={{ height: 24, width: 24, fill: "black" }}
                                                        />
                                                    }
                                                />
                                            )}
                                            {selectedAccess.activated && (
                                                <Chip
                                                    style={{
                                                        color: "black",
                                                        marginRight: 0,
                                                        width: "auto",
                                                    }}
                                                    disabled={((location?.state?.customerId && !location?.state?.permissions?.canEdit && location?.state?.permissions?.canEdit !== undefined) || (!location?.state?.customerId && !location?.state?.canEdit)) || isImpersonationLocked()}
                                                    onClick={() => {
                                                        if (!isToastVisible) {
                                                            verifyBeforeUpdateStatus(
                                                                selectedAccess.id,
                                                                selectedAccess.blocked ? "unblock" : "block"
                                                            );
                                                        }
                                                    }}
                                                    label={
                                                        selectedAccess.blocked ? "Desbloquear" : "Bloquear"
                                                    }
                                                    icon={
                                                        <DeleteForeverOutlined
                                                            style={{ height: 24, width: 24, fill: "black" }}
                                                        />
                                                    }
                                                />
                                            )}
                                            <Chip
                                                style={{
                                                    color: "black",
                                                    marginRight: 0,
                                                    width: "auto",
                                                }}
                                                disabled={((location?.state?.customerId && !location?.state?.permissions?.canEdit && location?.state?.permissions?.canEdit !== undefined) || (!location?.state?.customerId && !location?.state?.canEdit)) || isImpersonationLocked()}
                                                onClick={() => {
                                                    if (!isToastVisible) {
                                                        verifyBeforeUpdateStatus(
                                                            selectedAccess.id,
                                                            selectedAccess.activated
                                                                ? "deactivate"
                                                                : "activate"
                                                        );
                                                    }
                                                }}
                                                label={
                                                    selectedAccess.activated ? "Desativar" : "Ativar"
                                                }
                                                icon={
                                                    <RemoveCircleOutlineOutlined
                                                        style={{ height: 24, width: 24, fill: "black" }}
                                                    />
                                                }
                                            />
                                            {isAdmin && selectedAccess.useGtf && (
                                                <Chip
                                                    style={{
                                                        color: "black",
                                                        marginRight: 0,
                                                        width: "auto",
                                                    }}
                                                    disabled={isImpersonationLocked()}
                                                    onClick={() => {
                                                        if (!isToastVisible) {
                                                            verifyBeforeResetPassword(selectedAccess.id);
                                                        }
                                                    }}
                                                    label="Resetar senha"
                                                    icon={
                                                        <LockResetOutlined
                                                            style={{ height: 24, width: 24, fill: "black" }}
                                                        />
                                                    }
                                                />
                                            )}
                                        </>
                                    )}
                                </Box>
                                <Box
                                    className="col-md-12"
                                    style={{ margin: "15px 0px 15px 0px" }}
                                >
                                    <FormControl
                                        className="form-group"
                                        style={{ display: "flex", width: "100%" }}
                                    >
                                        <InputLabel
                                            id="demo-multiple-password-label"
                                            shrink
                                            required
                                            disabled={
                                                (selectedAccess?.name &&
                                                    !inEdit &&
                                                    !inInsert) as boolean
                                            }
                                            style={{ fontFamily: "Prometo" }}
                                        >
                                            Nome
                                        </InputLabel>
                                        <TextField
                                            name="name"
                                            required
                                            autoComplete="off"
                                            InputProps={{
                                                label: "Nome",
                                                notched: true,
                                                style: { fontFamily: "Prometo" },
                                            }}
                                            disabled={
                                                (selectedAccess?.name &&
                                                    !inEdit &&
                                                    !inInsert) as boolean
                                            }
                                            value={name}
                                            onChange={(e) => {
                                                handleChange(e.target.name, e.target.value);
                                            }}
                                            type="text"
                                            className="form-control form-control-login"
                                            placeholder="Digite o nome"
                                        />
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            className="visibility-password"
                                            disabled
                                            onMouseDown={(e: SyntheticEvent) => { }}
                                            edge="end"
                                            size="large"
                                        >
                                            <BadgeOutlined />
                                        </IconButton>
                                    </FormControl>
                                </Box>

                                {getCurrentUser.configs.isManager && location?.state?.customerId && <Box
                                    className="col-md-12"
                                    style={{ margin: "15px 0px 15px 0px" }}
                                >
                                    <FormGroup>
                                        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                                            <IOSSwitch
                                                title="Usar login gtf para cadastro"
                                                checked={useGtf}
                                                disabled={!getCurrentUser.configs.isManager || (selectedAccess?.name &&
                                                    !inEdit &&
                                                    !inInsert) as boolean}
                                                onChange={(event) => {
                                                    const checked = event.target.checked;

                                                    if (!checked) {
                                                        setLogin("");
                                                    }
                                                    setEmail("");
                                                    setUseGtf(checked);
                                                }}
                                                inputProps={{ 'aria-label': 'ant design' }}
                                            />
                                            <Typography style={{ color: "gray" }}>Usa GTF</Typography>
                                        </Stack>
                                    </FormGroup>
                                </Box>}

                                <Box
                                    className="col-md-12"
                                    style={{ margin: "15px 0px 15px 0px" }}
                                >
                                    <FormControl
                                        className="form-group"
                                        style={{ display: "flex", width: "100%" }}
                                    >
                                        <InputLabel
                                            id="demo-multiple-E-mail-label"
                                            shrink
                                            required
                                            disabled={
                                                (selectedAccess?.name &&
                                                    !inEdit &&
                                                    !inInsert) as boolean
                                            }
                                            style={{ fontFamily: "Prometo" }}
                                        >
                                            E-mail
                                        </InputLabel>

                                        <TextField
                                            name="email"
                                            required
                                            autoComplete="off"
                                            InputProps={{
                                                label: "E-mail",
                                                notched: true,
                                                style: { fontFamily: "Prometo" },
                                            }}
                                            disabled={
                                                (selectedAccess?.name &&
                                                    !inEdit &&
                                                    !inInsert) as boolean
                                            }
                                            value={email}
                                            onChange={(e) => {
                                                handleChange(e.target.name, e.target.value);
                                            }}
                                            type="text"
                                            className="form-control form-control-login"
                                            placeholder="Digite o e-mail"
                                        />
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            className="visibility-password"
                                            disabled
                                            onMouseDown={(e: SyntheticEvent) => { }}
                                            edge="end"
                                            size="large"
                                        >
                                            <EmailOutlined />
                                        </IconButton>

                                    </FormControl>
                                </Box>

                                {useGtf && <Box
                                    className="col-md-12"
                                    style={{ margin: "15px 0px 15px 0px" }}
                                >
                                    <FormControl
                                        className="form-group"
                                        style={{ display: "flex", width: "100%" }}
                                    >
                                        <InputLabel
                                            id="demo-multiple-E-mail-label"
                                            shrink
                                            required={useGtf}
                                            disabled={
                                                (selectedAccess?.name &&
                                                    !inEdit &&
                                                    !inInsert) as boolean
                                            }
                                            style={{ fontFamily: "Prometo" }}
                                        >
                                            Login
                                        </InputLabel>

                                        <TextField
                                            name="login"
                                            required={useGtf}
                                            autoComplete="off"
                                            InputProps={{
                                                label: "login",
                                                notched: true,
                                                style: { fontFamily: "Prometo" },
                                            }}
                                            disabled={
                                                (selectedAccess?.name &&
                                                    !inEdit &&
                                                    !inInsert) as boolean
                                            }
                                            value={login}
                                            onChange={(e) => {
                                                handleChange(e.target.name, e.target.value);
                                            }}
                                            type="text"
                                            className="form-control form-control-login"
                                            placeholder="Digite o login GTR/GTF"
                                        />
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            className="visibility-password"
                                            disabled
                                            onMouseDown={(e: SyntheticEvent) => { }}
                                            edge="end"
                                            size="large"
                                        >
                                            <EmailOutlined />
                                        </IconButton>
                                    </FormControl>
                                </Box>}

                                {!selectedAccess.name && (
                                    <Box
                                        className="col-md-12"
                                        style={{ margin: "15px 0px 0px 0px" }}
                                    >
                                        <FormControl
                                            className="form-group"
                                            style={{ display: "flex", width: "100%" }}
                                        >
                                            <InputLabel
                                                id="demo-multiple-password-label"
                                                shrink
                                                required
                                                style={{ fontFamily: "Prometo" }}
                                                disabled={
                                                    (selectedAccess?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                            >
                                                Senha
                                            </InputLabel>
                                            <TextField
                                                name="password"
                                                required
                                                autoComplete="off"
                                                InputProps={{
                                                    label: "Senha",
                                                    notched: true,
                                                    style: { fontFamily: "Prometo" },
                                                }}
                                                disabled={
                                                    (selectedAccess?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                                value={password}
                                                onChange={(e) =>
                                                    handleChange(e.target.name, e.target.value)
                                                }
                                                type={isPasswordVisible ? "text" : "password"}
                                                className="form-control form-control-login"
                                                placeholder="Digite a senha"
                                            />
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                className="visibility-password"
                                                onClick={() => {
                                                    setIsPasswordVisible(!isPasswordVisible);
                                                }}
                                                edge="end"
                                                size="large"
                                                disabled={
                                                    (selectedAccess?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                            >
                                                {isPasswordVisible ? (
                                                    <VisibilityOffOutlined />
                                                ) : (
                                                    <VisibilityOutlined />
                                                )}
                                            </IconButton>
                                            <Box
                                                style={{
                                                    display: "flex",
                                                    marginTop: 10,
                                                    marginLeft: -15,
                                                }}
                                            >
                                                <FormHelperText
                                                    style={{
                                                        color: isWeakPassword ? "red" : "green",
                                                        display: "flex",
                                                    }}
                                                >
                                                    {isWeakPassword &&
                                                        password &&
                                                        "A senha deve ter no mínimo 8 digitos, conter uma letra maiúscula, uma letra minúscula, números e pelo menos um caractere especial."}
                                                    {!isWeakPassword && password && (
                                                        <>
                                                            <LockPersonOutlined style={{ marginRight: 5 }} />
                                                            <Typography>Senha forte</Typography>
                                                        </>
                                                    )}
                                                </FormHelperText>
                                            </Box>
                                        </FormControl>
                                    </Box>
                                )}

                                {getCurrentUser.configs.isManager && !location?.state?.customerId && <Box
                                    className="col-md-12"
                                    style={{ margin: "15px 0px 15px 0px" }}
                                >
                                    <Autocomplete
                                        id="chip-label-select-profile"
                                        className="input-select-profile"
                                        style={{
                                            width: "100%",
                                            minHeight: "56px",
                                            height: "56px",
                                            backgroundColor: "#ffffff29",
                                            borderColor: "lightgray",
                                        }}
                                        options={defaultManangerProfiles}
                                        value={defaultManangerProfiles.find((a) => a.name === userAccessProfileName) ?? null}
                                        onChange={(_, option) => {
                                            setUserAccessProfileName(option?.name ?? "");
                                            setAccess(option?.id === Number(PROFILE_ACESSES.TECHNICIAN)
                                                ? userTechnicianPermissionsDefault
                                                : userManagerPermissionsDefault);
                                        }}
                                        getOptionLabel={(option) => `${option.name}`}
                                        noOptionsText={"Nada encontrado"}
                                        renderInput={(params) => (
                                            <>
                                                <FormControl
                                                    className="form-group"
                                                    style={{ display: "flex" }}
                                                >
                                                    <InputLabel
                                                        id="country-label"
                                                        required
                                                        style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                                        shrink
                                                        disabled={
                                                            (selectedAccess?.name &&
                                                                !inInsert) as boolean
                                                        }
                                                    >
                                                        Perfil
                                                    </InputLabel>
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        placeholder="Selecione um perfil"
                                                        autoComplete="off"
                                                        required
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            notched: true,
                                                            label: "Perfil",
                                                            classes: {
                                                                notchedOutline: "custom-notch",
                                                            },
                                                        }}
                                                    />
                                                </FormControl>
                                            </>
                                        )}
                                        disabled={
                                            (selectedAccess?.name &&
                                                !inInsert) as boolean
                                        }
                                    />
                                </Box>}

                                {(location?.state?.customerId || !getCurrentUser.configs.isManager) && <>
                                    <Box className="col-md-12" style={{ margin: "15px 0px 15px 0px" }}>
                                        <Autocomplete
                                            id="chip-label-select-vehicle"
                                            className="input-select-vehicle"
                                            disabled={(selectedAccess?.name &&
                                                !inEdit &&
                                                !inInsert) as boolean}
                                            style={{
                                                width: "100%",
                                                backgroundColor: "#ffffff29",
                                                borderColor: "lightgray",
                                            }}
                                            multiple
                                            limitTags={2}
                                            onChange={(_, value) => {
                                                const list = value.map((a) => String(a.id));
                                                setSelectedSecretariesList(list);
                                                getDepartmentsList(list);
                                            }}
                                            options={secretariesList}
                                            value={secretariesList.filter((a) => selectedSecretariesList.includes(String(a.id)))}
                                            getOptionLabel={(option) => `${option?.reducedName}`}
                                            noOptionsText={"Nada encontrado"}
                                            renderInput={(params) => (
                                                <>
                                                    <FormControl
                                                        className="form-group"
                                                        style={{ display: "flex" }}
                                                    >
                                                        <InputLabel
                                                            id="vehicles-label"
                                                            required
                                                            style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                                            shrink
                                                            disabled={
                                                                (selectedAccess?.name &&
                                                                    !inEdit &&
                                                                    !inInsert) as boolean
                                                            }
                                                        >
                                                            Secretaria
                                                        </InputLabel>
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder="Selecione uma ou mais secretarias"
                                                            required
                                                            InputLabelProps={{ shrink: true }}
                                                            autoComplete="off"
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                notched: true,
                                                                label: "Secretaria",
                                                                classes: {
                                                                    notchedOutline: "custom-notch",
                                                                },
                                                            }}
                                                        />
                                                    </FormControl>
                                                </>
                                            )}
                                        />
                                    </Box>

                                    <Box className="col-md-12" style={{ margin: "15px 0px 15px 0px" }}>
                                        <Autocomplete
                                            id="chip-label-select-department"
                                            className="input-select-department"
                                            disabled={!selectedSecretariesList.length || (selectedAccess?.name &&
                                                !inEdit &&
                                                !inInsert) as boolean}
                                            style={{
                                                width: "100%",
                                                backgroundColor: "#ffffff29",
                                                borderColor: "lightgray",
                                            }}
                                            multiple
                                            limitTags={2}
                                            onChange={(_, value) => {
                                                const list = value.map((a) => String(a.id));
                                                setSelectedDepartmentList(list);
                                                getGroupsList(list);
                                            }}
                                            options={departmentsList}
                                            value={departmentsList.filter((a) => selectedDepartmentsList.includes(String(a.id)))}
                                            getOptionLabel={(option) => `${option?.reducedName}`}
                                            noOptionsText={"Nada encontrado"}
                                            renderInput={(params) => (
                                                <>
                                                    <FormControl
                                                        className="form-group"
                                                        style={{ display: "flex" }}
                                                    >
                                                        <InputLabel
                                                            id="vehicles-label"
                                                            required
                                                            style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                                            shrink
                                                            disabled={
                                                                (selectedAccess?.name &&
                                                                    !inEdit &&
                                                                    !inInsert) as boolean
                                                            }
                                                        >
                                                            Departamento
                                                        </InputLabel>
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder="Selecione um ou mais departamentos"
                                                            autoComplete="off"
                                                            required
                                                            InputLabelProps={{ shrink: true }}
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                notched: true,
                                                                label: "Departamento",
                                                                classes: {
                                                                    notchedOutline: "custom-notch",
                                                                },
                                                            }}
                                                        />
                                                    </FormControl>
                                                </>
                                            )}
                                        />
                                    </Box>
                                </>}

                                {!getCurrentUser.configs.isManager && <Box className="col-md-12" style={{ margin: "15px 0px 15px 0px" }}>
                                    <Autocomplete
                                        id="chip-label-select-department"
                                        className="input-select-department"
                                        disabled={!selectedDepartmentsList.length || (selectedAccess?.name &&
                                            !inEdit &&
                                            !inInsert) as boolean}
                                        style={{
                                            width: "100%",
                                            backgroundColor: "#ffffff29",
                                            borderColor: "lightgray",
                                        }}
                                        multiple
                                        limitTags={2}
                                        onChange={(_, value) => {
                                            setSelectedGroupsList(
                                                value.map((a) => String(a.id))
                                            );
                                        }}
                                        options={groupsList}
                                        value={groupsList.filter((a) => selectedGroupsList.includes(String(a.id)))}
                                        getOptionLabel={(option) => `${option?.name}`}
                                        noOptionsText={"Nada encontrado"}
                                        renderInput={(params) => (
                                            <>
                                                <FormControl
                                                    className="form-group"
                                                    style={{ display: "flex" }}
                                                >
                                                    <InputLabel
                                                        id="vehicles-label"
                                                        // required
                                                        style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                                        shrink
                                                        disabled={
                                                            (selectedAccess?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                    >
                                                        Grupo
                                                    </InputLabel>
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        placeholder="Selecione um ou mais departamentos"
                                                        autoComplete="off"
                                                        //required
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            notched: true,
                                                            label: "Grupo",
                                                            classes: {
                                                                notchedOutline: "custom-notch",
                                                            },
                                                        }}
                                                    />
                                                </FormControl>
                                            </>
                                        )}
                                    />
                                </Box>}

                                {!location?.state?.customerId && <Box className="col-sm-12 col-md-12 d-none d-md-flex" sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography variant="body1" sx={{ fontWeight: "bolder" }}>
                                        Permissões
                                    </Typography>
                                    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                                        <IOSSwitch
                                            checked={expandAllPermissions}
                                            onChange={(event) => {
                                                setExpandAllPermissions(event.target.checked);
                                            }}
                                        />
                                        <Typography style={{ color: "gray", fontSize: "14px" }}>Expandir todas</Typography>
                                    </Stack>
                                </Box>}

                                <Box
                                    className="row"
                                    sx={{
                                        maxHeight: '200px',
                                        overflowY: 'auto',
                                        overflowX: 'hidden',
                                        width: '100%',
                                        mt: 1,
                                        pr: 1,
                                        '&::-webkit-scrollbar': {
                                            width: '5px',
                                        },
                                        '&::-webkit-scrollbar-track': {
                                            background: 'rgba(0,0,0,0.05)',
                                            borderRadius: '10px',
                                        },
                                        '&::-webkit-scrollbar-thumb': {
                                            background: '#ccc',
                                            borderRadius: '10px',
                                        },
                                        '&::-webkit-scrollbar-thumb:hover': {
                                            background: '#bbb',
                                        },
                                    }}
                                >
                                    {!location?.state?.customerId && (getCurrentUser.configs.isManager
                                        ? itensManagerPermissions
                                        : itensCustomerPermissions
                                    ).filter((item) => !disabledPermissionIds.includes(item.id))
                                    .filter((item) => userAccessProfileName !== "Técnico" || TECHNICIAN_MENU_IDS.includes(item.id)).map((item) => (
                                        <Box className="col-sm-12 col-md-3">
                                            <SimpleTreeView
                                                className="simple-tree-permissions"
                                                onItemExpansionToggle={() => handleExpandToggle(item.id)}
                                                expandedItems={expandAllPermissions ? [item.id] : [item.id == expandedGroup ? item.id : "0"]}
                                                multiSelect={true}
                                            >
                                                <CustomTreeItem
                                                    itemId={item.id}
                                                    label={item.label}
                                                    disabled={!inEdit && !inInsert}
                                                    style={{ backgroundColor: "transparent" }}
                                                >
                                                    {item.children?.map((permission) => {
                                                        const checked =
                                                            access.find((ac) => ac.optionItemId === item.id)?.[
                                                            permission.id
                                                            ] ?? false;
                                                        return (
                                                            <FormControlLabel
                                                                style={{ marginRight: 5, marginLeft: 5 }}
                                                                control={
                                                                    <Checkbox
                                                                        id={permission.id + item.id}
                                                                        name={permission.id}
                                                                        disabled={!inEdit && !inInsert}
                                                                        checked={checked}
                                                                        onChange={(
                                                                            event: ChangeEvent<HTMLInputElement>
                                                                        ) => {
                                                                            handleItemSelectionToggle(
                                                                                item.id,
                                                                                event.target.name,
                                                                                event.target.checked
                                                                            );
                                                                        }}
                                                                    />
                                                                }
                                                                label={permission.label}
                                                            />
                                                        );
                                                    })}
                                                </CustomTreeItem>
                                            </SimpleTreeView>
                                        </Box>
                                    ))}
                                </Box>
                            </>
                        ) : (
                            loadingEsqueleton
                        )}
                    </Box>
                    <Box
                        className="tw-flex tw-w-full tw-flex-none tw-justify-end tw-border-t tw-border-black/10 tw-bg-white tw-p-4"
                        sx={{
                            display: "flex",
                            width: "100%",
                            alignSelf: "stretch",
                            justifyContent: "flex-end",
                            padding: 2,
                            borderTop: "1px solid rgba(0, 0, 0, 0.10)",
                            backgroundColor: "#ffff",
                        }}
                    >
                        <Paper
                            className="tw-flex tw-w-full tw-flex-col-reverse tw-gap-2 sm:tw-w-auto sm:tw-flex-row"
                            elevation={0}
                            sx={{
                                display: "flex",
                                flexDirection: { xs: "column-reverse", sm: "row" },
                                justifyContent: "flex-end",
                                width: { xs: "100%", sm: "auto" },
                                marginLeft: "auto",
                                alignSelf: "flex-end",
                                gap: 1,
                                background: "transparent",
                            }}
                        >
                            <Button
                                type="button"
                                style={{
                                    fontFamily: "Prometo",
                                    color: "#ffff",
                                    marginRight: 5,
                                }}
                                onClick={() => {
                                    if (!isToastVisible) {
                                        verifyBeforeCancel(selectedAccess);
                                    }
                                }}
                                className="btn btn-primary btn-block login-button-close tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                            >
                                <CloseOutlined style={{ marginRight: 5 }} />
                                <Typography
                                    className="forgot-password"
                                    style={{
                                        fontFamily: "Prometo",
                                        fontSize: "16px",
                                        color: "#ffff",
                                    }}
                                >
                                    Fechar
                                </Typography>
                            </Button>
                            <Button
                                type="button"
                                style={{ fontFamily: "Prometo", color: "#ffff" }}
                                disabled={!inEdit && !inInsert}
                                onClick={() => {
                                    inInsert && !inEdit ? onSave() : onUpdate();
                                }}
                                className="btn btn-primary btn-block login-button tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                            >
                                <SaveOutlined style={{ marginRight: 5 }} />
                                <Typography
                                    className="forgot-password"
                                    style={{
                                        fontFamily: "Prometo",
                                        fontSize: "16px",
                                        color: "#ffff",
                                    }}
                                >
                                    Salvar
                                </Typography>
                            </Button>
                        </Paper>
                    </Box>
                </Paper>
            </Rmodal>
        );
    }, [
        IOSSwitch,
        login,
        useGtf,
        expandedGroup,
        getCurrentUser.configs.isManager,
        location?.state?.permissions?.canEdit,
        userAccessProfileName,
        selectedSecretariesList,
        selectedDepartmentsList,
        secretariesList,
        departmentsList,
        getDepartmentsList,
        getGroupsList,
        isWeakPassword,
        verifyBeforeUpdateStatus,
        isPasswordVisible,
        selectedAccess,
        verifyBeforeCancel,
        access,
        CustomTreeItem,
        handleChange,
        handleItemSelectionToggle,
        location?.state?.canEdit,
        location?.state?.customerId,
        isToastVisible,
        validationText,
        isOpenDetails,
        loading,
        onSave,
        onUpdate,
        loadingEsqueleton,
        inInsert,
        inEdit,
        name,
        email,
        password,
        selectedGroupsList,
        groupsList,
        expandAllPermissions,
        disabledPermissionIds,
        isAdmin,
        verifyBeforeResetPassword
    ]);

    return (
        <>
            {DetailsModal}
            <Toast
                ref={toastRef}
                position="center"
                onShow={() => {
                    setIsToastVisible(true);

                    if (validationText) {
                        setTimeout(() => {
                            setFieldsIsValid(true);
                            setIsToastVisible(false);
                        }, 3000);
                    }
                }}
            />
            <GridTemplate
                columns={gridColumns}
                headerName={location?.state?.customerId ? "Acessos do cliente" : "Acessos"}
                isHiddenMenu={isHiddenMenu}
                isLoading={loading}
                order={"asc"}
                rows={rowsOptions(filteredList, (item: any) => {
                    setIsOpenDetails(true);
                    setSelectedAcess(item);
                }, accessUser, (getCurrentUser.configs.isManager && location.state?.customerId > -1))}
                sortField="name"
                withFilter={true}
                withOptions={true}
                query={query}
                setQuery={(value: string) => setQuery(value)}
                filterPlaceholder={"Nome ou e-mail"}
                onRefresh={getAllAccesses}
                onExport={getReport}
                disableAddButton={
                    (location?.state?.customerId &&
                        !location?.state?.permissions?.canCreate &&
                        location?.state?.permissions?.canCreate !== undefined) ||
                    (!location?.state?.customerId && !location?.state?.canCreate)
                }
                handleNext={(activated: string, page: number, size: number) => getAllAccesses("", activated, page, size)}
                handlePrevious={() => { }}
                isLastPage={isLastPage}
                totalPerPage={numberOfElementsPerPage}
                currentPage={pageNumber}
                totalElements={numberOfElements}
                onAdd={() => {
                    setIsOpenDetails(true);
                    setInInsert(true);
                    setLoading(true);
                    setTimeout(() => {
                        setLoading(false);
                    }, 2000);
                }}
                onClickRow={(item: any) => {
                    setIsOpenDetails(true);
                    setSelectedAcess(item);
                    handleOnEditValues(item);
                    setLoading(true);
                    setTimeout(() => {
                        setLoading(false);
                    }, 2000);
                }}
            />
        </>
    );
};

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    width: { xs: "calc(100vw - 24px)", sm: "min(94vw, 1100px)" },
    maxWidth: 1100,
    maxHeight: "calc(100dvh - 24px)",
    overflow: "hidden",
    bgcolor: "#ffff",
    border: "none",
    boxShadow: "none",
    borderRadius: 4,
    color: "black",
    justifyContent: "center",
    alignItems: "center",
    lineBreak: "anywhere",
    padding: 0,
    fontFamily: "Prometo",
};

export default AccessPage;
